<template>
    <div class="row justify-content-center mt-5 triple-table">
        <template v-if="isBuilt">
            <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
            </div>
            <template v-if="title1 || title2">
                <h1 class="section-name col-6 mb-3 text-uppercase">{{title1}}</h1>
                <h1 class="section-name col-6 mb-3 text-uppercase">{{title2}}</h1>
            </template>
            <div v-if="showQueries" v-html="this.query" class="query-wrap">{{ this.query }}</div>
            <template v-if="missed_some_metric.length">
                <div class="missed-accounts my-3">There is an issue with the section below. The issue is likely caused by no metrics connected. Change the metrics/remove this section in the builder.</div>
            </template>
            <template v-else-if="!!missed_accounts.length">
                <div v-for="missed_account in missed_accounts" class="missed-accounts my-3">There are no accounts connected for {{missed_account}}. Either connect an account or change the metrics/remove this section in the builder.</div>
            </template>
            <div  class="col-12 col-md-6 d-flex flex-column justify-content-center mt-2">
                <div class="table-wrap flex-grow-1 p-3 table_1" :class="{'no-compare':!show_compare1, 'one-metric':tableData.metrics['table_1'].length==1, 'multiple':is_multiple1, 'social-media':is_social_media1, 'make_table_blue':make_table1_blue}">
                    <h3 class="table-title text-uppercase font-weight-normal mb-5">{{tableData.tables[1].table_name}}</h3>
                    <template v-if="tblData1.length && !reloading">
                        <v-client-table :data="tblData1" :columns="columns1" :options="options1">
                            <template v-for="(column, idx) in columns1" :slot="column" slot-scope="props">
                                <template v-if="show_arrow1 || show_percent_change1">
                                    <span v-if="column.includes('seg')" :title="props.row[column]['title']">{{props.row[column]['value']}}</span>
                                    <template v-else>
                                        <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                        <template v-if="props.row[column]['sign'] == 'na'">
                                            <template v-if="show_arrow1">
                                                <span v-if="show_percent_change1" class="arrow-wrap with-percentage" :class="['column-'+idx]"><span class="arrow" :class="[props.row[column]['sign']]"></span>{{props.row[column]['perc']}}</span>
                                                <span v-else class="arrow-wrap without-percentage"><span class="arrow" :class="[props.row[column]['sign'], 'column-'+idx]"></span></span>
                                            </template>
                                            <template v-else>
                                                <span v-if="show_percent_change1" class="arrow-wrap with-percentage without-arrow" :class="['column-'+idx]">{{props.row[column]['perc']}}</span>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <template v-if="show_arrow1">
                                                <span v-if="show_percent_change1" class="arrow-wrap with-percentage" :class="['column-'+idx]"><span class="arrow" :class="[props.row[column]['sign']]"></span>{{props.row[column]['perc']}}%</span>
                                                <span v-else class="arrow-wrap without-percentage"><span class="arrow" :class="[props.row[column]['sign'], 'column-'+idx]"></span></span>
                                            </template>
                                            <template v-else>
                                                <span v-if="show_percent_change1" class="arrow-wrap with-percentage without-arrow" :class="['column-'+idx]">{{props.row[column]['perc']}}%</span>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    <span v-if="column.includes('seg')" :title="props.row[column]['title']">{{props.row[column]['value']}}</span>
                                    <span v-else :class="props.row">{{props.row[column]['value']}}</span>
                                </template>
                            </template>
                        </v-client-table>
                    </template>
                    <template v-else-if="is_index_comparison1">
                        <v-client-table :data="tblData1" :columns="columns1" :options="options1">
                            <template v-for="(column, idx) in columns1" :slot="column" slot-scope="props">
                                <template v-if="(show_arrow || show_percent_change) && !(column == 'metric')">
                                    <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                    <template v-if="props.row[column]['sign'] == 'na'">
                                        <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                        <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                    </template>
                                    <template v-else>
                                        <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                                        <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                    </template>
                                </template>
                                <span v-else>{{props.row[column]['value']}}</span>
                            </template>
                        </v-client-table>
                    </template>
                    <template v-else>
                        <div class="nodata-container p-5 text-center">
                            <div v-if="errors || missed_some_metric[1]" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                            <div v-else class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="col-12 col-md-6 d-flex flex-column justify-content-between mt-2">
                <div class="row justify-content-center mb-2">
                    <div class="col">
                        <div class="table-wrap p-3 table_2" :class="[{'google':tableData.type == 'google', 'no-compare':!show_compare2, 'one-metric':tableData.metrics['table_2'].length==1, 'multiple':is_multiple2, 'social-media':is_social_media2, 'make_table_blue':make_table2_blue}, num_metrics2]">
                            <h3 class="table-title text-uppercase font-weight-normal mb-1">{{tableData.tables[2].table_name}}</h3>
                            <template v-if="tblData2.length && !reloading">
                                <v-client-table :data="tblData2" :columns="columns2" :options="options2">
                                    <template v-for="(column, idx) in columns2" :slot="column" slot-scope="props">
                                        <template v-if="show_arrow2 || show_percent_change2">
                                            <span v-if="column.includes('seg')" :title="props.row[column]['title']">{{props.row[column]['value']}}</span>
                                            <template v-else>
                                                <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                                <template v-if="props.row[column]['sign'] == 'na'">
                                                    <template v-if="show_arrow2">
                                                        <span v-if="show_percent_change2" class="arrow-wrap with-percentage" :class="['column-'+idx]"><span class="arrow" :class="[props.row[column]['sign']]"></span>{{props.row[column]['perc']}}</span>
                                                        <span v-else class="arrow-wrap without-percentage"><span class="arrow" :class="[props.row[column]['sign'], 'column-'+idx]"></span></span>
                                                    </template>
                                                    <template v-else>
                                                        <span v-if="show_percent_change2" class="arrow-wrap with-percentage without-arrow" :class="['column-'+idx]">{{props.row[column]['perc']}}</span>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="show_arrow2">
                                                        <span v-if="show_percent_change2" class="arrow-wrap with-percentage" :class="['column-'+idx]"><span class="arrow" :class="[props.row[column]['sign']]"></span>{{props.row[column]['perc']}}%</span>
                                                        <span v-else class="arrow-wrap without-percentage"><span class="arrow" :class="[props.row[column]['sign'], 'column-'+idx]"></span></span>
                                                    </template>
                                                    <template v-else>
                                                        <span v-if="show_percent_change2" class="arrow-wrap with-percentage without-arrow" :class="['column-'+idx]">{{props.row[column]['perc']}}%</span>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <span v-if="column.includes('seg')" :title="props.row[column]['title']">{{props.row[column]['value']}}</span>
                                            <span v-else>{{props.row[column]['value']}}</span>
                                        </template>
                                    </template>
                                </v-client-table>
                            </template>
                            <template v-else-if="is_index_comparison2">
                                <v-client-table :data="tblData2" :columns="columns2" :options="options2">
                                    <template v-for="(column, idx) in columns2" :slot="column" slot-scope="props">
                                        <template v-if="(show_arrow || show_percent_change) && !(column == 'metric')">
                                            <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <template v-if="props.row[column]['sign'] == 'na'">
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                            <template v-else>
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                        </template>
                                        <span v-else>{{props.row[column]['value']}}</span>
                                    </template>
                                </v-client-table>
                            </template>
                            <template v-else>
                                <div class="nodata-container p-5 text-center">
                                    <div v-if="errors || missed_some_metric[2]" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                                    <div v-else class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col">
                        <div class="table-wrap p-3 table_3" :class="[{'no-compare':!show_compare3, 'one-metric':tableData.metrics['table_3'].length==1, 'multiple':is_multiple3, 'social-media':is_social_media3, 'make_table_blue':make_table3_blue}, num_metrics3]">
                            <h3 class="table-title text-uppercase font-weight-normal mb-1">{{tableData.tables[3].table_name}}</h3>
                            <template v-if="tblData3.length && !reloading">
                                <v-client-table :data="tblData3" :columns="columns3" :options="options3">
                                    <template v-for="(column, idx) in columns3" :slot="column" slot-scope="props">
                                        <template v-if="show_arrow3 || show_percent_change3">
                                            <span v-if="column.includes('seg')" :title="props.row[column]['title']">{{props.row[column]['value']}}</span>
                                            <template v-else>
                                                <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                                <template v-if="props.row[column]['sign'] == 'na'">
                                                    <template v-if="show_arrow3">
                                                        <span v-if="show_percent_change3" class="arrow-wrap with-percentage" :class="['column-'+idx]"><span class="arrow" :class="[props.row[column]['sign']]"></span>{{props.row[column]['perc']}}</span>
                                                        <span v-else class="arrow-wrap without-percentage"><span class="arrow" :class="[props.row[column]['sign'], 'column-'+idx]"></span></span>
                                                    </template>
                                                    <template v-else>
                                                        <span v-if="show_percent_change3" class="arrow-wrap with-percentage without-arrow" :class="['column-'+idx]">{{props.row[column]['perc']}}</span>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="show_arrow3">
                                                        <span v-if="show_percent_change3" class="arrow-wrap with-percentage" :class="['column-'+idx]"><span class="arrow" :class="[props.row[column]['sign']]"></span>{{props.row[column]['perc']}}%</span>
                                                        <span v-else class="arrow-wrap without-percentage"><span class="arrow" :class="[props.row[column]['sign'], 'column-'+idx]"></span></span>
                                                    </template>
                                                    <template v-else>
                                                        <span v-if="show_percent_change3" class="arrow-wrap with-percentage without-arrow" :class="['column-'+idx]">{{props.row[column]['perc']}}%</span>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <span v-if="column.includes('seg')" :title="props.row[column]['title']">{{props.row[column]['value']}}</span>
                                            <span v-else>{{props.row[column]['value']}}</span>
                                        </template>
                                    </template>
                                </v-client-table>
                            </template>
                            <template v-else-if="is_index_comparison3">
                                <v-client-table :data="tblData3" :columns="columns3" :options="options3">
                                    <template v-for="(column, idx) in columns3" :slot="column" slot-scope="props">
                                        <template v-if="(show_arrow || show_percent_change) && !(column == 'metric')">
                                            <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <template v-if="props.row[column]['sign'] == 'na'">
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                            <template v-else>
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                        </template>
                                        <span v-else>{{props.row[column]['value']}}</span>
                                    </template>
                                </v-client-table>
                            </template>
                            <template v-else>
                                <div class="nodata-container p-5 text-center">
                                    <div v-if="errors || missed_some_metric[3]" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                                    <div v-else class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'hasSkb', 'tableData'],
        created() {
            if(this.isBuilt){
                this.num_rows = this.tableData.element_configurations.num_rows;
                this.show_index_values = this.tableData.element_configurations.show_index_values;
                this.index_name = this.show_index_values ? this.tableData.element_configurations.select_index_name : null;
                this.show_arrow1 = !!parseInt(this.tableData['tables'][1].reporting_table_type_configurations.show_change_arrows);
                this.show_arrow2 = !!parseInt(this.tableData['tables'][2].reporting_table_type_configurations.show_change_arrows);
                this.show_arrow3 = !!parseInt(this.tableData['tables'][3].reporting_table_type_configurations.show_change_arrows);
                this.show_percent_change1 = !!parseInt(this.tableData['tables'][1].reporting_table_type_configurations.show_percentage_change);
                this.show_percent_change2 = !!parseInt(this.tableData['tables'][2].reporting_table_type_configurations.show_percentage_change);
                this.show_percent_change3 = !!parseInt(this.tableData['tables'][3].reporting_table_type_configurations.show_percentage_change);
                this.show_compare1 = this.show_arrow1 || this.show_percent_change1;
                this.show_compare2 = this.show_arrow2 || this.show_percent_change2;
                this.show_compare3 = this.show_arrow3 || this.show_percent_change3;
                this.is_social_media1 = this.tableData.segments['table_1']['table_type'] == 'Social Media Advertising';
                this.is_social_media2 = this.tableData.segments['table_2']['table_type'] == 'Social Media Advertising';
                this.is_social_media3 = this.tableData.segments['table_3']['table_type'] == 'Social Media Advertising';
                this.is_advert_sources1 = this.tableData.segments['table_1']['table_type'] == 'Advertising Sources';
                this.is_advert_sources2 = this.tableData.segments['table_2']['table_type'] == 'Advertising Sources';
                this.is_advert_sources3 = this.tableData.segments['table_3']['table_type'] == 'Advertising Sources';
                this.is_index_comparison1 = this.tableData.segments['table_1']['table_type'] == 'Index Comparison';
                this.is_index_comparison2 = this.tableData.segments['table_2']['table_type'] == 'Index Comparison';
                this.is_index_comparison3 = this.tableData.segments['table_3']['table_type'] == 'Index Comparison';
                this.is_multiple1 = this.is_social_media1 || this.is_advert_sources1;
                this.is_multiple2 = this.is_social_media2 || this.is_advert_sources2;
                this.is_multiple3 = this.is_social_media3 || this.is_advert_sources3;
                this.make_table1_blue = !!parseInt(this.tableData['tables'][1].reporting_table_type_configurations.make_table_blue);
                this.make_table2_blue = !!parseInt(this.tableData['tables'][2].reporting_table_type_configurations.make_table_blue);
                this.make_table3_blue = !!parseInt(this.tableData['tables'][3].reporting_table_type_configurations.make_table_blue);
                this.exclude_branded_terms1 = (this.tableData['tables'][1].table_type == 'Keywords') ? this.tableData['tables'][1].reporting_table_type_configurations.exclude_branded_terms : false;
                this.exclude_branded_terms2 = (this.tableData['tables'][2].table_type == 'Keywords') ? this.tableData['tables'][2].reporting_table_type_configurations.exclude_branded_terms : false;
                this.exclude_branded_terms3 = (this.tableData['tables'][3].table_type == 'Keywords') ? this.tableData['tables'][3].reporting_table_type_configurations.exclude_branded_terms : false;
                this.language_filter1 = (this.tableData['tables'][1].table_type == 'Keywords') ? this.tableData['tables'][1].reporting_table_type_configurations.language_filter : false;
                this.language_filter2 = (this.tableData['tables'][2].table_type == 'Keywords') ? this.tableData['tables'][2].reporting_table_type_configurations.language_filter : false;
                this.language_filter3 = (this.tableData['tables'][3].table_type == 'Keywords') ? this.tableData['tables'][3].reporting_table_type_configurations.language_filter : false;
                this.terms_to_include1 = (this.tableData['tables'][1].table_type == 'Keywords') ? this.tableData['tables'][1].reporting_table_type_configurations.terms_to_include : false;
                this.terms_to_include2 = (this.tableData['tables'][2].table_type == 'Keywords') ? this.tableData['tables'][2].reporting_table_type_configurations.terms_to_include : false;
                this.terms_to_include3 = (this.tableData['tables'][3].table_type == 'Keywords') ? this.tableData['tables'][3].reporting_table_type_configurations.terms_to_include : false;
                this.show_channel_groupings1 = (this.tableData['tables'][1].table_type == 'Campaigns') ? this.tableData['tables'][1].reporting_table_type_configurations.show_channel_groupings : false;
                this.show_channel_groupings2 = (this.tableData['tables'][2].table_type == 'Campaigns') ? this.tableData['tables'][2].reporting_table_type_configurations.show_channel_groupings : false;
                this.show_channel_groupings3 = (this.tableData['tables'][3].table_type == 'Campaigns') ? this.tableData['tables'][3].reporting_table_type_configurations.show_channel_groupings : false;
                this.index_comparison1 = this.is_index_comparison1 ? this.tableData['tables'][1].reporting_table_type_configurations.index_comparison : null;
                this.index_comparison2 = this.is_index_comparison2 ? this.tableData['tables'][2].reporting_table_type_configurations.index_comparison : null;
                this.index_comparison3 = this.is_index_comparison3 ? this.tableData['tables'][3].reporting_table_type_configurations.index_comparison : null;
                this.table_name = this.tableData.name;
                this.filter_element = this.tableData.element_configurations.filter_element;
                this.num_metrics1 = 'num_metrics_' + this.tableData.metrics['table_1'].length;
                this.num_metrics2 = 'num_metrics_' + this.tableData.metrics['table_2'].length;
                this.num_metrics3 = 'num_metrics_' + this.tableData.metrics['table_3'].length;
                this.fetchServerData();
                this.missed_some_metric = this.checkMissedTables(this.tableData);
                this.missed_accounts = this.checkAccounts(this.tableData);
            }
        },
        mounted(){
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        updated(){
            $('table.VueTables__table').each(function(idx, el){
                const table = $(el);
                for(let i=0;i<10;i++){
                    let max_w = 0;
                    const bw = $('body').width();
                    table.find('span.value-with-additionals.column-'+i).each(function(i, e){
                        max_w = Math.max(max_w, parseInt($(e).width()));
                    });
                    table.find('span.value-with-additionals.column-'+i).width(max_w);
                    max_w = 0;
                    table.find('span.arrow-wrap.column-'+i).each(function(i, e){
                        max_w = Math.max(max_w, parseInt($(e).width()));
                    });
                    table.find('span.arrow-wrap.column-'+i).width(max_w*1.1);
                    if(bw < 1400){
                        table.find('span.arrow-wrap.column-'+i).width('50%');
                    }
                }

            });
        },
        data() {
            return {
                missed_accounts:[],
                missed_some_metric:[],
                isArchive:this.$store.state.isArchive,
                filter_element: null,
                table_name:null,
                descr:{},
                columns1:[],
                columns2:[],
                columns3:[],
                options1:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    skin: 'table'
                },
                options2:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    skin: 'table'
                },
                options3:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    skin: 'table'
                },
                tblData1:[],
                tblData2:[],
                tblData3:[],
                num_rows:10,
                show_compare1:false,
                show_compare2:false,
                show_compare3:false,
                show_arrow1:false,
                show_arrow2:false,
                show_arrow3:false,
                show_percent_change1:false,
                show_percent_change2:false,
                show_percent_change3:false,
                is_social_media1:false,
                is_social_media2:false,
                is_social_media3:false,
                is_advert_sources1:false,
                is_advert_sources2:false,
                is_advert_sources3:false,
                is_multiple1:false,
                is_multiple2:false,
                is_multiple3:false,
                make_table1_blue:false,
                make_table2_blue:false,
                make_table3_blue:false,
                exclude_branded_terms1:false,
                exclude_branded_terms2:false,
                exclude_branded_terms3:false,
                language_filter1:false,
                language_filter2:false,
                language_filter3:false,
                terms_to_include1:false,
                terms_to_include2:false,
                terms_to_include3:false,
                show_channel_groupings1:false,
                show_channel_groupings2:false,
                show_channel_groupings3:false,
                is_index_comparison1:false,
                is_index_comparison2:false,
                is_index_comparison3:false,
                num_metrics1:null,
                num_metrics2:null,
                num_metrics3:null,
                show_index_values:false,
                index_name:null,
                errors:false,
                query:'',
                showQueries:    this.$store.state.showQueries,
                reloading:true
            }
        },
        methods: {
            fetchServerData(){
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.isArchive ? this.tableData.archive_id : this.tableData.report_id,
                    'element_abbr':this.tableData.element_abbreviation,
                    'has_multiple_tables':true,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.tableData.element_id,
                    'prefixed_element_id': this.tableData.report_element_id,
                    'element_name':this.tableData.name,
                    'metrics': this.tableData.metrics,
                    'segments': this.tableData.segments,
                    'accounts': this.tableData.accounts,
                    'tables':this.tableData.tables,
                    'num_rows':this.num_rows,
                    'exclude_branded_terms1':this.exclude_branded_terms1,
                    'exclude_branded_terms2':this.exclude_branded_terms2,
                    'exclude_branded_terms3':this.exclude_branded_terms3,
                    'language_filter1':this.language_filter1,
                    'language_filter2':this.language_filter2,
                    'language_filter3':this.language_filter3,
                    'terms_to_include1':this.terms_to_include1,
                    'terms_to_include2':this.terms_to_include2,
                    'terms_to_include3':this.terms_to_include3,
                    'show_channel_groupings1':this.show_channel_groupings1,
                    'show_channel_groupings2':this.show_channel_groupings2,
                    'show_channel_groupings3':this.show_channel_groupings3,
                    'is_index_comparison1':this.is_index_comparison1,
                    'is_index_comparison2':this.is_index_comparison2,
                    'is_index_comparison3':this.is_index_comparison3,
                    'index_comparison1':this.index_comparison1,
                    'index_comparison2':this.index_comparison2,
                    'index_comparison3':this.index_comparison3,
                    'show_index_values': this.show_index_values,
                    'index_name':this.index_name,
                    'client_id':this.tableData.client_id,
                    'client_name':this.tableData.client_name,
                    'filter_element':this.filter_element,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb,
                };

                axios.post('/api/reporting/element', params).then((response) => {
                    if(!!response.data && (typeof(response.data) == 'object')){
                        let data = response.data;
                        this.query = data.query;
                        this.errors = data['errors'];
                        if(!this.errors){
                            this.columns1 = _.has(data, 'table_1') ? data.table_1.columns : [];
                            this.columns2 = _.has(data, 'table_2') ? data.table_2.columns : [];
                            this.columns3 = _.has(data, 'table_3') ? data.table_3.columns : [];
                            this.options1.headings = _.has(data, 'table_1') ? data.table_1.headings : [];
                            this.options2.headings = _.has(data, 'table_2') ? data.table_2.headings : [];
                            this.options3.headings = _.has(data, 'table_3') ? data.table_3.headings : [];
                            this.tblData1 = _.has(data, 'table_1') ? data.table_1.tblData : [];
                            this.tblData2 = _.has(data, 'table_2') ? data.table_2.tblData : [];
                            this.tblData3 = _.has(data, 'table_3') ? data.table_3.tblData : [];
                        }
                    }

                    this.reloading = false;
                });
            }
        },
        computed:{
            title1:function(){
                const split = this.table_name.split('/');
                return split[0].trim();
            },
            title2:function(){
                const split = this.table_name.split('/');
                if(split.length > 1){
                    return split[1].trim();
                }
                return null;
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.triple-table{
        .VueTables__table {
            th, td {
                font-size: 1.44rem;
            }
        }
        .table{
            margin-bottom:0 !important;
        }
        .table thead{
            th{
                border-bottom:none !important;
                text-transform:uppercase !important;
                &:nth-child(n+2){
                    text-align:center;
                }
            }
        }
        span.value-with-additionals{
            display:inline-block;
            text-align:right;
        }
        span.arrow-wrap{
            display:inline-block;
            text-align:left;
            &.without-arrow{
                margin-left:1rem;
            }
        }
        div.table-wrap {
            border-radius:2rem;
            span.arrow-wrap{
                font-size:0.625vw;
                @media screen and (max-width: 992px) {
                    font-size:2.2vw !important;
                }
                span.arrow {
                    font-size:0.75vw;
                    &::before {
                        border-left: 0.5vw solid transparent;
                        border-right: 0.5vw solid transparent;
                        content: "";
                        display: inline-block;
                        height: 0;
                        width: 0;
                        margin-right:0.4rem;
                    }
                }
            }

            tbody tr {
                line-height:1.4;
                td{
                    &:nth-child(n+2){
                        text-align:center;
                    }
                }
            }
            &.table_1{
                border:0.2rem solid $black-blue;
                h3, div.tbl1{
                    color:$black-blue;
                }
                tbody tr {
                    border-bottom: 0.1rem solid $black-blue;
                    line-height:2.2;
                }
                span.arrow {
                    &.up{
                        &::before {
                            border-bottom: 0.8rem dashed $black-blue;
                        }
                    }
                    &.down{
                        &::before {
                            border-top: 0.8rem dashed $black-blue;
                        }
                    }
                }
            }
            &.table_2{
                border:0.2rem solid $light-blue;

                h3, div.tbl2{
                    color:$light-blue;
                }
                &.google{
                    background-color:$light-blue;
                    h3{
                        color:white;
                    }
                    div.tbl2{
                        color:$black-blue;
                    }
                }

                tbody tr {
                    border-bottom: 0.1rem solid $light-blue;
                }
                &.google{
                    tbody tr {
                        border-bottom: 0.1rem solid $black-blue;
                    }
                }
                span.arrow {
                    &.up{
                        &::before {
                            border-bottom: 0.8rem dashed $light-blue;
                        }
                    }
                    &.down{
                        &::before {
                            border-top: 0.8rem dashed $light-blue;
                        }
                    }
                }
            }
            &.table_3{
                border:0.2rem solid $gold;
                h3, div.tbl3{
                    color:$gold;
                }
                tbody tr {
                    border-bottom: 0.1rem solid $gold;
                }
                span.arrow {
                    &.up{
                        &::before {
                            border-bottom: 0.8rem dashed $gold;
                        }
                    }
                    &.down{
                        &::before {
                            border-top: 0.8rem dashed $gold;
                        }
                    }
                }
            }
            &.make_table_blue{
                border:0.2rem solid $light-blue;
                background-color:$light-blue;
                h3, div.tbl2{
                    color:white;
                }
                tbody tr {
                    border-bottom: 0.1rem solid $black-blue;
                }
                span.arrow {
                    &.up{
                        &::before {
                            border-bottom: 0.8rem dashed $black-blue;
                        }
                    }
                    &.down{
                        &::before {
                            border-top: 0.8rem dashed $black-blue;
                        }
                    }
                }
            }
            &.one-metric{
                div.arrow-wrap{
                    font-size:0.875vw;
                    @media screen and (max-width: 992px) {
                        font-size:2.2vw !important;
                    }
                    margin-top:0;
                    span.arrow {
                        &::before {
                            border-left-width: 0.9375vw;
                            border-right-width: 0.9375vw;
                            border-top-width:0.75vw;
                            border-bottom-width:0.75vw;
                            margin-right:1rem;
                        }
                    }
                }
                &.no-compare{
                    &:not(.multiple){
                        tbody tr {
                            td{
                                width:100%;
                            }
                        }
                    }
                }
            }
        }
        div.multiple{
            &.social-media{
                tbody tr {
                    td:nth-child(1), td:nth-child(2), td:nth-child(3){
                        text-align:left;
                        word-break: break-word;
                    }
                }
                thead tr{
                    th:nth-child(1), th:nth-child(2), th:nth-child(3){
                        text-align:left;
                    }
                }
            }
            &.advert{
                tbody tr {
                    td:nth-child(1), td:nth-child(2){
                        text-align:left;
                        word-break: break-word;
                    }
                }
                thead tr{
                    th:nth-child(1), th:nth-child(2){
                        text-align:left;
                    }
                }
            }
        }
        div.query-wrap{
            width:100%;
        }
        .num_metrics_2{
            th:first-child{
                min-width:14vw !important;
            }
        }
        .num_metrics_3{
            th:first-child{
                min-width:12vw !important;
            }
        }
        .num_metrics_4{
            th:first-child{
                min-width:10vw !important;
            }
        }
        .num_metrics_5{
            th:first-child{
                min-width:8vw !important;
            }
        }
    }
</style>
